export const truncateFloat = (number, fractionDigits) => {
  const multiplier = Math.pow(10, fractionDigits)

  return Math.trunc(number*multiplier) / multiplier
}
